import { render, staticRenderFns } from "./HotelCard.vue?vue&type=template&id=2618e049&scoped=true"
import script from "./HotelCard.vue?vue&type=script&lang=js"
export * from "./HotelCard.vue?vue&type=script&lang=js"
import style0 from "./HotelCard.vue?vue&type=style&index=0&id=2618e049&prod&lang=scss"
import style1 from "./HotelCard.vue?vue&type=style&index=1&id=2618e049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618e049",
  null
  
)

export default component.exports